let lastScrollTop = 0;


(function(){
  // ⚡ Fast + smooth + elastic
  const AMP_EM   = 0.25;    // amplitude de base
  const MAX_DEG  = 5;       // rotation max
  const STAGGER_SPAN = 30;  // décalage total entre lettres (ms)

  const DURATION_UP_BASE   = 90;
  const DURATION_DOWN_BASE = 120;
  const DURATION_BACK_BASE = 140;

  const EASE_UP   = 'cubic-bezier(.16,1,.3,1)';      // départ rapide, fin douce
  const EASE_DOWN = 'cubic-bezier(.22,.8,.24,1)';
  const EASE_BACK = 'cubic-bezier(.25,.6,.2,1)';

  const easeOutCubic = x => 1 - Math.pow(1 - x, 3);
  const easeOutQuad  = x => 1 - (1 - x) * (1 - x);
  const lerp = (a,b,t)=> a + (b - a) * t;

  // Init quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once:true });
  } else { initAll(); }

  function initAll(){
    document.querySelectorAll('.pam-cta-swing').forEach(initSwing);
  }

  function initSwing(btn){
    // span direct enfant (fallback si besoin)
    let root = btn.querySelector(':scope > span') || btn.querySelector('span');
    if (!root) { root = document.createElement('span'); root.textContent = btn.textContent.trim(); btn.textContent=''; btn.appendChild(root); }

    const text = root.textContent;
    root.textContent = '';

    // split lettres
    const letters = [...text].map(ch=>{
      const s = document.createElement('span');
      s.className='l';
      s.textContent = ch===' ' ? '\u00A0' : ch;
      s.style.display = 'inline-block';
      s.style.willChange = 'transform';
      root.appendChild(s);
      return s;
    });

    const n = letters.length;
    const t = i => (n<=1 ? 0 : i/(n-1));

    // Stagger non linéaire (rapide au début, lissé ensuite)
    const delayFor = i => easeOutCubic(t(i)) * STAGGER_SPAN;
    // Durée légèrement plus longue sur les dernières lettres (fin plus smooth)
    const scaleFor = i => lerp(1, 1.18, easeOutQuad(t(i)));

    // Courbe et angle
    const yArc   = (i, sign=1, amp=AMP_EM) => sign * (-Math.sin(Math.PI*t(i)) * amp);
    const degArc = (i, sign=1)           => (-Math.cos(Math.PI*t(i)) * MAX_DEG * sign); // sens corrigé

    const transformFor = (i, sign, amp=AMP_EM) => sign===0
      ? 'translateY(0) rotate(0deg)'
      : `translateY(${yArc(i,sign,amp)}em) rotate(${degArc(i,sign)}deg)`;

    function pose(sign, ampScale, baseDur, easing){
      const amp = AMP_EM * ampScale;
      return Promise.all(letters.map((el,i)=>{
        const from = getComputedStyle(el).transform==='none'
          ? 'translateY(0) rotate(0deg)' : undefined;
        const anim = el.animate(
          [{ transform: from }, { transform: transformFor(i, sign, amp) }],
          { duration: baseDur*scaleFor(i), delay: delayFor(i), easing, fill:'forwards' }
        );
        return anim.finished.catch(()=>{});
      }));
    }

    function backToFlat(baseDur, easing){
      return Promise.all(letters.map((el,i)=>{
        const from = getComputedStyle(el).transform==='none'
          ? 'translateY(0) rotate(0deg)' : undefined;
        const anim = el.animate(
          [{ transform: from }, { transform: 'translateY(0) rotate(0deg)' }],
          { duration: baseDur*scaleFor(i), delay: delayFor(i), easing, fill:'forwards' }
        );
        return anim.finished.catch(()=>{});
      }));
    }

    let running = false;
    async function elasticSeq(){
      if (running) return;
      running = true;
      try {
        // 1) Monte plein
        await pose( 1, 1.00, DURATION_UP_BASE,   EASE_UP   );
        // 2) Descend plein
        await pose(-1, 1.00, DURATION_DOWN_BASE, EASE_DOWN );
        // 3) Petit rebond vers le haut (amplitude réduite)
        await pose( 1, 0.45, Math.round(DURATION_UP_BASE*0.9), 'cubic-bezier(.18,1,.3,1)');
        // 4) Retour à plat (un peu plus long pour la douceur)
        await backToFlat(Math.round(DURATION_BACK_BASE*1.1), EASE_BACK);
      } finally { running = false; }
    }

    btn.addEventListener('pointerenter', elasticSeq);
    btn.addEventListener('pointerleave', ()=> backToFlat(120, EASE_BACK));
  }

  window.initializeCtaSwings = initSwing
})();


window.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger)
  window.addEventListener("scroll", scrolling);
  
  document.fonts.ready.then(() => {
    setTimeout(headerInit, 500)
  })

  
  addToCartInit();
  trialInit();
  initHomeHeroRandom()
  
  // const lenis = new Lenis();
  // lenis.on("scroll", ScrollTrigger.update);
  // gsap.ticker.add((time) => {
  //   lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  // });
  // gsap.ticker.lagSmoothing(0);

});





function initHomeHeroRandom(){
  const homeHeroRandom = document.getElementById('homeHeroRandom');
    if (homeHeroRandom) {
      // Add click event listener
      homeHeroRandom.addEventListener('click', () => {
        // Get all hero visuals
        const visuals = document.querySelectorAll('.home-hero-single-visual');
        if (visuals.length <= 1) return;

        // Find the currently visible visual
        const visibleVisual = document.querySelector('.home-hero-single-visual:not(.visual-hidden)');
        if (!visibleVisual) return;

        // Hide the current visual
        visibleVisual.classList.add('visual-hidden');

        // Select a random visual that's different from the current one
        let availableVisuals = Array.from(visuals).filter((v) => v !== visibleVisual);
        const randomIndex = Math.floor(Math.random() * availableVisuals.length);
        availableVisuals[randomIndex].classList.remove('visual-hidden');
      });
    }
}

function globalScrollTriggerRefresh() {
  console.log("globalScrollTriggerRefresh");
  const tmp = window.scrollY;
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
  ScrollTrigger.refresh();
  window.scrollTo({
    top: tmp,
    left: 0,
    behavior: "instant",
  });
}

function trialInit() {
  const buttons = document.querySelectorAll(".js-toggle-trial");
  buttons.forEach((item) => {
    item.addEventListener("click", () => {
      document.getElementById("trial-drawer").classList.toggle("on");
    });
  });
}

function addToCartInit() {
  const buttons = document.querySelectorAll(".js-add-to-cart");
  buttons.forEach((item) => {
    item.addEventListener("click", async () => {
      item.classList.add("loading");
      // Curseur "progress" sur toute la page : feedback immédiat qui reste
      // affiché pendant le chargement de /cart.
      document.documentElement.classList.add("is-busy");

      const ok = await addToCart(
        item.getAttribute("data-product-id"),
        item.getAttribute("data-license-id"),
        item.getAttribute("data-pack-id"),
      );

      // On ne nettoie QUE si l'ajout a échoué (sinon la navigation /cart est en
      // cours et on veut garder le curseur jusqu'au chargement de la page).
      if (!ok) {
        item.classList.remove("loading");
        document.documentElement.classList.remove("is-busy");
      }
    });
  });
}

async function addToCart(id, license, pack) {
  try {
    // Clear d'un éventuel code de réduction — en tâche de fond, ne bloque PAS le Buy.
    // La requête part quand même (discount purgé côté serveur), on n'attend pas la
    // redirection vers le domaine de checkout. mode no-cors pour éviter l'erreur CORS en local.
    fetch(window.Shopify.routes.root + 'checkout?discount=CLEAR', {
      method: 'GET',
      mode: 'no-cors',
    }).catch((e) => console.warn('Clear discount ignoré:', e));

    // Vider le panier
    const clearResponse = await fetch(
      window.Shopify.routes.root + "cart/clear.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const clearData = await clearResponse.json();

    if (clearData.message) {
      console.error(clearData);
      return false;
    }

    // Ajouter un article au panier
    let formData = {
      items: [
        {
          id: parseInt(id),
          quantity: 1,
        },
        // {
        //   id: parseInt(license),
        //   quantity: 1,
        // },
      ],
    };

    if (pack) {
      // formData.items.push({
      //   id: parseInt(pack),
      //   quantity: 1,
      // });
    }

    const addResponse = await fetch(
      window.Shopify.routes.root + "cart/add.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      },
    );

    const addData = await addResponse.json();

    if (addData.message) {
      console.error(addData);
      return false;
    }
    window.location.href = window.Shopify.routes.root + "cart";
    return true;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
}


function headerInit() {
  const header = document.querySelector("header");
  const footer = document.querySelector("footer");
  if (!header || !footer) return;

  const onScroll = () => {
    const pageHeight = document.documentElement.scrollHeight;
    const vh = window.innerHeight + 80;
    const y = window.scrollY;

    // Derniers 100vh uniquement
    const inLast100vh = y >= (pageHeight - vh);

    header.style.top = inLast100vh ? "-80px" : "0";
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}


function scrolling() {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;
  window.scrollY > 100 && scrollTop > lastScrollTop
    ? document.documentElement.classList.add("scroll-down")
    : document.documentElement.classList.remove("scroll-down");
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

  if (window.scrollY > 10) document.documentElement.classList.add("not-top");
  else document.documentElement.classList.remove("not-top");
}

function goTo(div, offset) {
  window.scrollTo({
    top: document.querySelector(div).offsetTop - offset,
    left: 0,
    behavior: "smooth",
  });
}

function is_touch_device() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function addToCartErrors(message) {
  document.querySelector(".product_errors").classList.remove("hidden");
  document.querySelector(".product_errors_message").textContent = message;
  return false;
}
function hideAddToCartErrors() {
  document.querySelector(".product_errors").classList.add("hidden");
}

function minQuantity(e) {
  var currentValue = e.parentNode.querySelector("input").value;
  if (currentValue == 1) return;

  currentValue--;
  e.parentNode.querySelector("input").value = currentValue;
  e.parentNode.querySelector("span").innerText = currentValue;
}

window.updateCart = () => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  fetch(window.location.href)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Pas de réponse réseau " + response.statusText);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const cartDrawer = doc.querySelector("#cart-drawer");
      if (cartDrawer) {
        document.querySelector("#cart-drawer").innerHTML = cartDrawer.innerHTML;
      } else {
        console.error("#cart-drawer non trouvé sur la page");
      }
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    })
    .catch((error) => {
      console.error("Erreur fetch :", error);
      document.querySelector("#cart-drawer")?.classList.remove("loading");
    });

  updateCartLink();
};

window.reduceQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("span").textContent) - 1;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        if (quantity === 0) el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de mettre à jour le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.increaseQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;
  const quantity =
    parseInt(el.parentNode.querySelector("span").textContent) + 1;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=${quantity}`,
  })
    .then((response) => response.json())
    .then((data) => {
      const erreurs = data.errors || data.description;
      if (erreurs) {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.remove("hidden");
        el.parentNode.parentNode.parentNode.querySelector(
          ".product_errors_message",
        ).textContent = erreurs;
        document.querySelector("#cart-drawer")?.classList.remove("loading");
        return false;
      } else {
        el.parentNode.parentNode.parentNode
          .querySelector(".product_errors")
          .classList.add("hidden");
        window.updateCart();
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};
/*
const erreurs = data.errors || data.description
    if(erreurs) {
      e.target.querySelector('.product_errors').classList.remove('hidden')
      e.target.querySelector('.product_errors_message').textContent = erreurs
      e.target.querySelector('[type="submit"]').disabled = false
      return false
    } else {
      e.target.querySelector('.product_errors').classList.add('hidden')
    }
  */

window.removeQty = (el) => {
  document.querySelector("#cart-drawer")?.classList.add("loading");
  const itemId = el.closest(".cartDrawer_item").dataset.id;

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    },
    body: `updates[${itemId}]=0`,
  })
    .then((response) => {
      if (response.ok) {
        window.updateCart();
        el.closest(".cartDrawer_item").remove();
      } else {
        console.error("Impossible de vider le cart");
      }
    })
    .catch((error) => console.error("Erreur :", error));

  return false;
};

window.emptyCart = () => {
  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {})
    .catch((error) => {
      console.error("Erreur emptyCart :", error);
    });
};

function updateCartLink() {
  fetch("/cart/update")
    .then((response) => response.text())
    .then((data) => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "text/html");

      let newCartContent = doc.querySelector(".open-cart-link").innerHTML;
      document.querySelector(".open-cart-link").innerHTML = newCartContent;
    })
    .catch((error) =>
      console.error("Erreur lors de la mise à jour du panier :", error),
    );
}
